import React from 'react';

const FooterDetails = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-title">NS TUNNEL BRAND</p>
        <p className="footer-copy">&copy; 2024 FixBuild. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterDetails;
